import MainComponent from "components/Main";
import PropTypes from 'prop-types';

import { ReactComponent as EditIcon } from 'icons/buttons/edit.svg';
import { ReactComponent as CloseIcon } from 'icons/components/close.svg';

import './index.less';
import './themes/default.less';

export default class TabsPage extends MainComponent {
    static propTypes = {
        info: PropTypes.object,
        name: PropTypes.string,
        opened: PropTypes.bool,
        absol: PropTypes.bool,
    };

    static defaultProps = {
        info: null,
        name: "",
        opened: false,
        absol: false,
    };

    onOpenDialog({ name, period, reasonId, infoVis }) {
        const { info, addUpdateRepeatedVisit, openDialog, clinicId } = this.props;
        openDialog("invite", name, period, info, reasonId, infoVis, addUpdateRepeatedVisit, clinicId);
    }

    openDeleteDialog(id, text) {
        this._helper.confirm({
            title: "client.deleteRepVisit",
            message: this.tr("client.deleteRepVisitMessage") + text
        }, this.props.deleteRepeatedVisit.bind(this, id));
    }

    renderRow(title, component, color, key) {
        const props = {};

        return (
            <div key={key || "div" + this._helper.number.random(1, 200)} className="detailRow flex text p1 gap8" {...props}>
                <div className="rowTitle selectable">{this.tr(title)}</div>
                <div className={`${color ? "compColor" + color : ""} flex1  selectable`}>{component}</div>
            </div>
        );
    }

    renderContent() {
        return <></>;
    }

    renderBlockInfo(text, date, comment, id, onOpenDialog) {
        return (<div className="blokInfo flex rad4">
            <div className="blokInfoData">
                <div>{text}</div>
                {comment && <div>{comment}</div>}
                <div>{date}</div>
            </div>
            <div className="active flex centerV">
                <div className="hand" onClick={onOpenDialog}>
                    <EditIcon />
                </div>
                <div className="hand" onClick={this.openDeleteDialog.bind(this, id, text)}>
                    <CloseIcon />
                </div>
            </div>
        </div>);
    }

    renderRowInfo(it, req) {
        const title = it.visitRule.title;
        const comment = it.visitRule.comment;
        const nextDate = this._helper.date.toDateStr(it.targetDate);
        const id = it.id;

        return this.renderBlockInfo(title, nextDate, comment, id, this.onOpenDialog.bind(this, { ...req, infoVis: it }));
    }

    renderRowInv(key, item) {
        const { invitePeriod } = this._config;
        const { repeatedVisits } = this.props.info;

        const name = this.tr("client." + item.name);
        const period = invitePeriod.filter(it => it.attr.includes(item.name));
        const rv = (repeatedVisits || []).filter(it => it.title === this.tr("client." + item.name));
        const req = { name, period, reasonId: item.id };

        if (rv.length < 1) {
            return (
                <div key={key} className={"visRow hand"} onClick={this.onOpenDialog.bind(this, req)}>{name}</div>
            );
        }

        return rv.map((it, i) => (
            <div key={key + "_" + i} className="wrapBlokInfo flex col gap8">
                {this.renderRowInfo(it, req)}
            </div>
        ));
    }

    render() {
        const { name, opened } = this.props;
        const { absol } = this.state;
        const { invite } = this._config;

        const cl = opened ? " opened" : "";
        const ab = absol ? " absol" : "";

        return (
            <div className="tabsPage pos rel flex1 flex minH0">
                <div className={`pageContent flex flex1 scrolling ${name}`}>
                    {this.renderContent()}
                </div>
                <div className={"returnVisits scrolling transit06 " + cl + ab}>
                    <div className="inner flex col gap24 text p1SemiBold">
                        {Object.keys(invite).map((it, i) => this.renderRowInv(i, invite[it]))}
                    </div>
                </div>
            </div>
        );
    }
}
